import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

export const SENSEMAKER_LIST_SEARCH_PARAM = 'q'

export function useSensemakerListSearch() {
  const [searchParams, setSearchParams] = useSearchParams()
  const search = searchParams.get(SENSEMAKER_LIST_SEARCH_PARAM) ?? ''

  const setSearch = useCallback(
    (value: string) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev)
          if (value) {
            next.set(SENSEMAKER_LIST_SEARCH_PARAM, value)
          } else {
            next.delete(SENSEMAKER_LIST_SEARCH_PARAM)
          }
          return next
        },
        { replace: true },
      )
    },
    [setSearchParams],
  )

  return { search, setSearch }
}
